export const reimbursementType = [
  { value: "Travel", label: "Travel" },
  { value: "Office", label: "Office" },
  { value: "Hardware", label: "Hardware" },
  { value: "Software", label: "Software" },
  { value: "Party", label: "Party" },
  { value: "Food", label: "Food" },
  { value: "Other", label: "Other" },
];

export const reimbursementUnitOption = [
  { value: "INR", label: "INR" },
  { value: "USD", label: "USD" },
];

export const reimbursementStatus = [
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "INITIATED", label: "Initiated" },
  { value: "PAID", label: "Paid" }
];